import React from "react"
import Location from "../../../components/location/Location"
import { IJobDocument, IGeoLocation } from "../../../models"
import _ from "lodash"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as permissionHelper from "../../../helpers/permissionHelper"

interface IProps {
    job: IJobDocument
    handleUpdateJob(job: IJobDocument): void
}

const JobDetailLocation: React.SFC<IProps> = (props: IProps) => {
    const handleChange = (geoLocation: IGeoLocation) => {
        const job = _.cloneDeep(props.job)
        job.IsLocation = geoLocation.IsLocation
        job.IsMicroLocation = geoLocation.IsMicroLocation
        job.Location = geoLocation.Location
        job.MicroLocation = geoLocation.MicroLocation
        job.DisableLocationException = geoLocation.DisableLocationException
        props.handleUpdateJob(job)
    }

    return (
        <div style={{ padding: "40px 30px 30px 30px" }}>
            <Location
                jobLocation
                parentHierarchyId={props.job.HierarchyId}
                readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.EditJobLocation)}
                objectId={props.job.Id}
                geoLocation={props.job}
                handleChangeGeoLocation={handleChange}
            />
        </div>
    )
}

export default JobDetailLocation